import React from "react";
import { Chip } from "@mui/material";

function CustomChip({ status }) {
  const chipColor = (status) => {
    switch (status) {
      case "Submitted":
      case "Closed":
        return "#757575";

      case "In Progress":
        return "#078667";

      case "Pending Confirmation":
      case "Pending Response":
        return "#F38729";

      default:
        return "#757575";
    }
  };
  return (
    <Chip
      label={status}
      size="small"
      sx={{
        justifyContent: "flex-end",
        alignSelf: "center",
        backgroundColor: chipColor(status),
        color: "white",
        fontFamily: "Open Sans",
        fontWeight: 600,
        fontSize: "12px",
      }}
    />
  );
}

export default CustomChip;
